var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.localShow)?_c('div',{class:_vm.classObject,attrs:{"role":"alert","aria-live":"polite","aria-atomic":"true"}},[(_vm.dismissible)?_c('b-btn-close',{attrs:{"aria-label":_vm.dismissLabel},on:{"click":_vm.dismiss}},[_vm._t("dismiss")],2):_vm._e(),_vm._v(" "),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29af3a4e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/bootstrap-vue/es/components/alert/alert.vue
// module id = 936
// module chunks = 75